import { supabase } from '@/integrations/supabase/client';
import type { Tables } from '@sylva/shared-types/database';

export type ServiceRow = Tables<'appointment_types'>;
export type ServiceCategoryRow = Tables<'appointment_type_categories'>;

export type ServiceWithCategory = ServiceRow & {
  appointment_type_categories: Pick<ServiceCategoryRow, 'id' | 'name' | 'display_order'> | null;
};

export const fetchServices = async (tenantId: string): Promise<ServiceWithCategory[]> => {
  const { data, error } = await supabase
    .from('appointment_types')
    .select(`
      *,
      appointment_type_categories (
        id,
        name,
        display_order
      )
    `)
    .eq('tenant_id', tenantId)
    .order('created_at', { ascending: false });

  if (error) throw error;
  return (data || []) as unknown as ServiceWithCategory[];
};

